/* eslint-disable @typescript-eslint/no-explicit-any */

interface ICallbackFunction extends Function {
    selectTimeOut?: number;
    amountOfCall?: number;
}

export default class Extensions {

    static executeTimeout(callBack: Function, timeout: number, scope?: any, ...args: any[]) {
        const extendedFunction = <ICallbackFunction>callBack;
        if (extendedFunction.selectTimeOut) {
            clearTimeout(extendedFunction.selectTimeOut);
        }
        extendedFunction.selectTimeOut = window.setTimeout(() => {
            callBack.apply(scope, args);
        }, timeout);
    }

    static getSmsEmail(phone: string): string {
        let contactPhone = phone.replace(new RegExp(' ', 'g'), '').replace('+', '00');
        contactPhone += '@msg.ecall.ch';
        return contactPhone;
    }

    static capitalizeFirstLetter(s: string) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    static getDecimal(num: number): number {
        return num > 0 ? (num % 1) : (-num % 1);
    }
}